import axios from 'axios'
import url from '../../urls'
// import router from '../../router'

export default {
  CREATE_NEW_RECORD_IN_DB({ commit, dispatch }, data) {
    commit('CREATE_RECORD_LOADING', true)
    return axios({
      method: 'POST',
      url: `${url.CREATE_NEW_RECORD_IN_DB_URL}/${data.dbId}`,
      data: data.model
    })
      .then(response => {
        commit('CREATE_NEW_RECORD_SUCCESS', response)
        dispatch('GET_DB_RECORDS_LIST', { id: data.dbId })
        commit('CREATE_RECORD_LOADING', false)
      })
      .catch(error => {
        commit('CREATE_NEW_RECORD_ERROR', error.response.data.message)
        commit('CREATE_RECORD_LOADING', false)
      })
  },
  CREATE_NEW_RECORD_AND_EXIT({ commit, dispatch }, data) {
    commit('CREATE_RECORD_LOADING', true)
    return axios({
      method: 'POST',
      url: `${url.CREATE_NEW_RECORD_IN_DB_URL}/${data.dbId}`,
      data: data.model
    })
      .then(response => {
        commit('CREATE_NEW_RECORD_AND_EXIT_SUCCESS', response)
        dispatch('GET_DB_RECORDS_LIST', { id: data.dbId })
        commit('CREATE_RECORD_LOADING', false)
      })
      .catch(error => {
        commit('CREATE_NEW_RECORD_AND_EXIT_ERROR', error.response.data.message)
        commit('CREATE_RECORD_LOADING', false)
      })
  },
  GET_DB_RECORDS_LIST({ commit }, data) {
    return axios({
      method: 'GET',
      url: url.GET_DB_RECORDS_LIST_URL,
      params: {
        formId: data.id,
        page: data.page,
        size: data.size,
        fieldId: data.fieldId,
        sort: data.sort
      }
    })
      .then(response => {
        commit('GET_DB_RECORDS_LIST_SUCCESS', response.data.result)
      })
      .catch(error => {
        commit('GET_DB_RECORDS_LIST_ERROR', error.response.data.message)
      })
  },
  SEND_EXCEL_FILE({ commit, dispatch }, data) {
    commit('UPLOAD_EXCEL_LOADING', true)
    axios({
      method: 'POST',
      url: url.SEND_EXCEL_FILE_URL,
      data
    })
      .then(response => {
        commit('UPLOAD_EXCEL_LOADING_SUCCESS', response)
        commit('UPLOAD_EXCEL_LOADING', false)
      })
      .catch(error => {
        commit('UPLOAD_EXCEL_FILE_ERROR', error)
        commit('UPLOAD_EXCEL_LOADING', false)
      })
  },
  DELETE_RECORD({ commit, dispatch }, id) {
    return axios({
      method: 'DELETE',
      url: `/api/Db/delete/record/${id}`
    })
      .then(response => {
        commit('DELETE_RECORD_SUCCESS', response)
      })
      .catch(error => {
        commit('DELETE_RECORD_ERROR', error)
      })
  },
  EDIT_RECORD({ commit, dispatch }, data) {
    return axios({
      method: 'POST',
      url: `/api/Db/edit/record/${data.id}`,
      data: data.model
    })
      .then(response => {
        commit('EDIT_RECORD_SUCCESS', response)
        dispatch('GET_DB_RECORDS_LIST', { id: data.dbId, page: data.page, size: data.size })
      })
      .catch(error => {
        commit('EDIT_RECORD_ERROR', error.response.data.message)
      })
  },
  SEARCH_DB_RECORDS({ commit }, data) {
    return axios({
      method: 'POST',
      url: url.SEARCH_DB_RECORDS_URL,
      data
    })
      .then(response => {
        commit('SEARCH_DB_RECORDS_SUCCESS', response.data.result)
      })
      .catch(error => {
        commit('SEARCH_DB_RECORDS_ERROR', error.response.data.message)
      })
  },
  GET_USER_FORM_FIELDS({ commit }, payload) {
    return axios({
      method: 'GET',
      url: url.SET_USER_FORM_SETTINGS_URL + `/${payload.id}`
    })
      .then(response => {
        commit('GET_USER_FORM_FIELDS_SUCCESS', response.data.result)
      })
      .catch(error => {
        console.log(error.response.data.message)
        // commit('', error)
      })
  },
  POST_USER_FORM_FIELDS({ commit, dispatch }, payload) {
    commit('POST_USER_FORM_FIELDS_LOADING', true)
    axios({
      method: 'POST',
      url: url.SET_USER_FORM_SETTINGS_URL + `/${payload.id}`,
      data: payload.fields
    })
      .then(response => {
        commit('POST_USER_FORM_FIELDS_SUCCESS', response.data)
        dispatch('GET_DB_RECORDS_LIST', { id: payload.id, page: payload.page, size: payload.size })
        commit('POST_USER_FORM_FIELDS_LOADING', false)
      })
      .catch(error => {
        commit('POST_USER_FORM_FIELDS_ERROR', error.response.data.message)
        commit('POST_USER_FORM_FIELDS_LOADING', false)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/db/actions.js